export default {"src":"/_next/static/media/gmx.cc5aea9f.svg","height":847,"width":2500,"blurWidth":0,"blurHeight":0};